import Service from "./service";
import WebW from "../../../assets/webw.webp";
import WebG from "../../../assets/webg.webp";
import MobileW from "../../../assets/mobilew.webp";
import MobileG from "../../../assets/mobileg.webp";
import WindowsG from "../../../assets/windowsg.webp";
import WindowsW from "../../../assets/windowsw.webp";
import CustomizeG from "../../../assets/customizeg.webp";
import CustomizeW from "../../../assets/customizew.webp";
import { Link } from "react-scroll";


const Services = () => {
    return (
        <div className="services-container" id="services">
            <div className="services-details">
                <div className="dash"></div>
                <h4>Services We Provide</h4>
                <p>
                    At AmorServ Solutions, we stand out as a beacon of multifaceted services. From assisting your team in effective software product discovery to deployment and application maintenance, each service we offer is a testament to our commitment to excellence, innovation, and understanding the unique needs of our clients.
                </p>
                <Link to="schedule" spy={true} smooth={true} offset={-100} duration={2000}>
                    <button type="button">Schedule A Call With Us</button>
                </Link>
            </div>
            <div className="services">
                <Service
                    img1={WebG}
                    img2={WebW}
                    title={"Web Design & Development."}
                    desc={"A captivating and user-friendly website is essential for any business. Our web design and development services focus on creating visually appealing, responsive, and highly functional websites that engage your audience and drive results."}    
                />

                <Service
                    img1={MobileG}
                    img2={MobileW}
                    title={"Mobile App Design & Development. "}
                    desc={"Our mobile app design and development services are designed to help your business thrive in the digital age. We create user-friendly, feature rich mobile applications for iOS and Android platforms."}
                />

                <Service
                    img1={WindowsG}
                    img2={WindowsW}
                    title={"Full-Cycle Product Development."}
                    desc={"We offer comprehensive product development services that take your concept from ideation to market-ready reality. Our team will work closely with you to understand your vision, conduct thorough research, and execute a well-defined development plan."}
                />

                <Service
                    img1={CustomizeG}
                    img2={CustomizeW}
                    title={"Custom Software Development."}
                    desc={"Our Highly skilled and experienced developers specialize in creating tailored software solutions that are designed to address your specific challenges and deliver the exact functionality you require."}
                />
            </div>
        </div>
    )
}

export default Services;